module.exports = __webpack_public_path__ + "media/lifestyle_home/kantroleft-c59886f6.png";